import AolAccess from 'components/layout/AolAccess'
import { connect } from 'react-redux'
import { setAolConfig, setAolName, setHideOverride, setPageParameters } from 'redux/actions'

const mapStateToProps = state => ({
  isLogged: state.user.isLogged,
  roles: state.user.roles,
  pages: state.aol.pages,
  aolConfigLoaded: state.aol.aolConfigLoaded,
  availableAol: state.aol.availableAol,
  accessRoles: state.user.accessRoles
})

const mapDispatchToProps = dispatch => ({
  setAolName: name => dispatch(setAolName(name)),
  setAolConfig: config => dispatch(setAolConfig(config)),
  setPlaceHoldersHideOverride: hide => dispatch(setHideOverride(hide)),
  setPageParameters: pageParameters => dispatch(setPageParameters(pageParameters))
})

export default connect(mapStateToProps, mapDispatchToProps)(AolAccess)
